"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePhoneNumber = exports.saveAccountData = exports.resetPasswordInitiate = exports.registerUser = exports.getAccountData = exports.deleteApp = exports.deactivate2FAAuthentication = exports.addBusinessPartner = void 0;
var _RestHelper = _interopRequireWildcard(require("../utils/RestHelper"));
var _CacheHandler = _interopRequireDefault(require("../utils/CacheHandler"));
var _mainConfig = require("../mainConfig");
var _accountDataApi = _interopRequireDefault(require("../cic/api/accountDataApi"));
var _accountDataApi2 = _interopRequireDefault(require("../csc/api/accountDataApi"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var currentApiSet = _mainConfig.isCICContentTree ? _accountDataApi.default : _accountDataApi2.default;
var addBusinessPartner = exports.addBusinessPartner = currentApiSet.addBusinessPartner,
  registerUser = exports.registerUser = currentApiSet.registerUser,
  deleteApp = exports.deleteApp = currentApiSet.deleteApp,
  resetPasswordInitiate = exports.resetPasswordInitiate = currentApiSet.resetPasswordInitiate,
  saveAccountData = exports.saveAccountData = currentApiSet.saveAccountData,
  deactivate2FAAuthentication = exports.deactivate2FAAuthentication = currentApiSet.deactivate2FAAuthentication;

// The rest is the same for both contexts

var getAccountData = exports.getAccountData = function getAccountData() {
  return new Promise(function (resolve) {
    resolve({
      data: _CacheHandler.default.getCurrentCacheByToken('accountData')
    });
  });
};
var validatePhoneNumber = exports.validatePhoneNumber = function validatePhoneNumber(phoneNumber) {
  var pattern = new RegExp('^(\\+[1-9]|[0-9])[\\d\\s\\-]+$');
  if (!pattern.test(phoneNumber) || phoneNumber.length > 18) {
    var data = {
      errors: [{}]
    };
    return Promise.resolve({
      data: data
    });
  }
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicAccount), "/public-api/v1/validations/phonenumber"), {
    data: {
      type: 'ValidationResource',
      attributes: {
        toBeValidate: phoneNumber
      }
    }
  }, {}, true, false);
};